<template>
  <v-navigation-drawer
    v-model="drawer"
    app
    temporary
  >
    <router-link to="/">
      <v-img
        :src="require('@/assets/Logo_Altenheim_lang_5cm.png')"
        class="mr-5"
        contain
        height="48"
        max-height="48"
        max-width="200"
      />
    </router-link>
    
    <v-list v-for="(link, i) in this.$store.state.menuItems" :key="i">
      <v-list-item
        v-if="!link.dropdown"
        router
        :to="link.link"
        class="v-list-item ml-4"
      >
      {{link.text}}
      </v-list-item>

      <v-list-group
        v-else
        no-action
      >
        <template v-slot:activator>
          <v-list-item>
            {{ link.text }}
          </v-list-item>
        </template>

        <v-list-item
          v-for="sublink in link.dropdown"
          :to="sublink.link"
          :key="sublink.text"
        >
          {{sublink.text}}
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import {
    mapGetters,
    mapMutations,
  } from 'vuex'

  export default {
    name: 'CoreDrawer',

    computed: {
      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.setDrawer(val)
        },
      },
    },

    methods: {
      ...mapMutations(['setDrawer']),
      onClick (e, item) {
        e.stopPropagation()

        if (item.to === '/') {
          this.$vuetify.goTo(0)
          this.setDrawer(false)
          return
        }

        if (item.to || !item.link) return

        this.$vuetify.goTo(item.link)
        this.setDrawer(false)
      },
    },
  }
</script>
